import type { ExerciseInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { exerciseSliceActions } from '@/entities/exercise/model/exercise.slice';
import { useAppDispatch } from '@/hooks/store.hook';

interface ExercisesResponse {
	data: ExerciseInfo[];
}

function useLoadAllExercisesRawQuery() {
	const dispatch = useAppDispatch();

	const queryResult = useQuery<ExercisesResponse, Error>({
		queryKey: ['exercises', 'all', 'raw'],
		queryFn: () => api.get<ExercisesResponse>('exercises/raw'),
		staleTime: Number.POSITIVE_INFINITY,
	});

	// Automatically cache fetched exercises in the normalized store
	useEffect(() => {
		if (queryResult.data?.data) {
			dispatch(exerciseSliceActions.setAll(queryResult.data.data));
		}
	}, [queryResult.data, dispatch]);

	return queryResult;
}

export { useLoadAllExercisesRawQuery };
